module.exports = __webpack_public_path__ + "static/media/cancer-OFF.cd3917f4.png";